import * as ActionTypes from '../displayMode';
export function setDisplayMode(data) {
    return { type: ActionTypes.SET_DISPLAY_MODE, data: data };
}



// WEBPACK FOOTER //
// ./src/actions/creators/displayMode.js